module.exports = __webpack_public_path__ + "img/course1.389e1e34.png";